import HedgeFull from '@svs/ui/react/icons/HedgeFull';
import HedgeHalf from '@svs/ui/react/icons/HedgeHalf';
import type { ReactNode } from 'react';

type HedgesProps = {
  halfHedgeCount: number;
  fullHedgeCount: number;
};

/**
 * The hedge count display, full / half.
 *
 * @param root0 input object
 * @param root0.halfHedgeCount how many half hedges
 * @param root0.fullHedgeCount how many full hedges
 * @returns div with the hedge counts
 */
export default function BetslipHedges({ halfHedgeCount, fullHedgeCount }: HedgesProps): ReactNode {
  return (
    <div className="grid auto-cols-max grid-flow-col items-center gap-x-[12px] text-nowrap [grid-area:hedges]">
      <div
        aria-label={`${fullHedgeCount} ${fullHedgeCount === 1 ? 'helgardering' : 'helgarderingar'}`}
        aria-live="polite"
      >
        <div aria-hidden className="grid grid-flow-col items-center lg:mr-[12px]">
          <div className="hidden sm:mr-[12px] sm:inline-block lg:hidden">Hel</div>
          <div className="hidden lg:mr-[12px] lg:inline-block">Helgarderingar</div>
          <HedgeFull className="mr-[6px] h-[16px] w-[16px] lg:mr-[12px] lg:h-[20px] lg:w-[20px]" />
          <div className="font-bold">{fullHedgeCount}</div>
        </div>
      </div>
      <div
        aria-label={`${halfHedgeCount} ${halfHedgeCount === 1 ? 'halvgardering' : 'halvgarderingar'}`}
        aria-live="polite"
      >
        <div aria-hidden className="grid grid-flow-col items-center">
          <div className="hidden sm:mr-[12px] sm:inline-block lg:hidden">Halv</div>
          <div className="hidden lg:mr-[12px] lg:inline-block">Halvgarderingar</div>
          <HedgeHalf className="mr-[6px] h-[16px] w-[16px] lg:mr-[12px] lg:h-[20px] lg:w-[20px]" />
          <div className="font-bold">{halfHedgeCount}</div>
        </div>
      </div>
    </div>
  );
}
